// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
// S-26-T — Folha de Contas (Registro mensal + Confronto). Mapa extraído do PDF oficial.

const fieldMap = {
  '900_1_Text_C': { label: 'Congregação ou circuito', section: 'Cabeçalho' },
  '900_2_Text_C': { label: 'Cidade', section: 'Cabeçalho' },
  '900_3_Text_C': { label: 'Província ou estado', section: 'Cabeçalho' },
  '900_4_Text_C': { label: 'Mês', section: 'Cabeçalho' },
  '900_5_Text_C': { label: 'Ano', section: 'Cabeçalho' },
  '900_6_Text_C': { label: 'Nome da conta "Outra"', section: 'Cabeçalho' },
};

// Registro: 52 linhas × (Data, Descrição, S, e 6 colunas de valores)
for (let n = 1; n <= 52; n++) {
  fieldMap[`900_${6 + n}_Text_C`] = { label: `Linha ${n} — Data`, section: 'Registro — Data/Descrição' };
  fieldMap[`900_${58 + n}_Text`] = { label: `Linha ${n} — Descrição da movimentação`, section: 'Registro — Data/Descrição' };
  fieldMap[`900_${110 + n}_Text_C`] = { label: `Linha ${n} — S (símbolo)`, section: 'Registro — Data/Descrição' };
  fieldMap[`901_${n}_S26Value`] = { label: `Linha ${n} — Donativos: Entrada`, section: 'Registro — Donativos' };
  fieldMap[`901_${53 + n}_S26Value`] = { label: `Linha ${n} — Donativos: Saída`, section: 'Registro — Donativos' };
  fieldMap[`902_${n}_S26Value`] = { label: `Linha ${n} — Conta bancária/Cofre: Entrada`, section: 'Registro — Conta bancária/Cofre' };
  fieldMap[`902_${53 + n}_S26Value`] = { label: `Linha ${n} — Conta bancária/Cofre: Saída`, section: 'Registro — Conta bancária/Cofre' };
  fieldMap[`903_${n}_S26Value`] = { label: `Linha ${n} — Outra: Entrada`, section: 'Registro — Outra conta' };
  fieldMap[`903_${53 + n}_S26Value`] = { label: `Linha ${n} — Outra: Saída`, section: 'Registro — Outra conta' };
}

Object.assign(fieldMap, {
  '901_53_S26TotalValue': { label: 'Total — Donativos: Entradas', section: 'Totais do Registro' },
  '901_106_S26TotalValue': { label: 'Total — Donativos: Saídas', section: 'Totais do Registro' },
  '902_53_S26TotalValue': { label: 'Total — Conta bancária/Cofre: Entradas', section: 'Totais do Registro' },
  '902_106_S26TotalValue': { label: 'Total — Conta bancária/Cofre: Saídas', section: 'Totais do Registro' },
  '903_53_S26TotalValue': { label: 'Total — Outra: Entradas', section: 'Totais do Registro' },
  '903_106_S26TotalValue': { label: 'Total — Outra: Saídas', section: 'Totais do Registro' },

  // Confronto — Conta bancária
  '904_1_Text_C': { label: 'Data do preenchimento (Conta bancária)', section: 'Confronto — Conta bancária' },
  '904_2_S26Amount': { label: '1. Saldo que aparece no extrato bancário', section: 'Confronto — Conta bancária' },
  '904_3_S26Amount': { label: '2. Depósitos registrados na Folha de Contas que não aparecem no extrato', section: 'Confronto — Conta bancária' },
  '904_4_S26Amount': { label: '3. Taxas bancárias não registradas na Folha de Contas', section: 'Confronto — Conta bancária' },
  '904_5_S26TotalAmount': { label: '4. Total dos itens 1 a 3', section: 'Confronto — Conta bancária' },
  '904_20_S26TotalAmount': { label: '6. Total das transferências/cheques não processados [soma do item 5]', section: 'Confronto — Conta bancária' },
  '904_21_S26Amount': { label: '7. Juros bancários não registrados na Folha de Contas', section: 'Confronto — Conta bancária' },
  '904_22_S26Amount': { label: '8. Donativos eletrônicos não registrados na Folha de Contas', section: 'Confronto — Conta bancária' },
  '904_23_S26TotalAmount': { label: '9. Saldo bancário [item 4 − itens 6, 7 e 8]', section: 'Confronto — Conta bancária' },

  // Confronto — Cofre
  '904_24_S26Amount': { label: '1. Dinheiro no cofre', section: 'Confronto — Cofre' },
  '904_25_S26Amount': { label: '2. Pagamentos realizados, mas ainda não registrados na Folha de Contas', section: 'Confronto — Cofre' },
  '904_26_S26Amount': { label: '3. Adiantamentos em aberto', section: 'Confronto — Cofre' },
  '904_27_S26TotalAmount': { label: '4. Saldo do cofre [Total dos itens 1 a 3]', section: 'Confronto — Cofre' },

  // Resumo
  '904_28_Text_C': { label: 'Do mês que termina em', section: 'Resumo' },
  '904_29_S26Amount': { label: 'Donativos — Saldo do mês anterior', section: 'Resumo' },
  '904_30_S26TotalAmount': { label: 'Donativos — Entrada', section: 'Resumo' },
  '904_31_S26TotalAmount': { label: 'Donativos — Saída', section: 'Resumo' },
  '904_32_S26TotalAmount': { label: 'Donativos — Total', section: 'Resumo' },
  '904_33_S26Amount': { label: 'Conta bancária/Cofre — Saldo do mês anterior', section: 'Resumo' },
  '904_34_S26TotalAmount': { label: 'Conta bancária/Cofre — Entrada', section: 'Resumo' },
  '904_35_S26TotalAmount': { label: 'Conta bancária/Cofre — Saída', section: 'Resumo' },
  '904_36_S26TotalAmount': { label: 'Conta bancária/Cofre — Total', section: 'Resumo' },
  '904_37_Text_C': { label: 'Outra — Nome da conta', section: 'Resumo' },
  '904_38_S26Amount': { label: 'Outra — Saldo do mês anterior', section: 'Resumo' },
  '904_39_S26TotalAmount': { label: 'Outra — Entrada', section: 'Resumo' },
  '904_40_S26TotalAmount': { label: 'Outra — Saída', section: 'Resumo' },
  '904_41_S26TotalAmount': { label: 'Outra — Total', section: 'Resumo' },
  '904_42_S26TotalAmount': { label: 'SALDO DISPONÍVEL NO FINAL DO MÊS', section: 'Resumo' },

  // Confronto de outra conta
  '904_43_Text_C': { label: 'Data do preenchimento (Outra conta)', section: 'Confronto — Outra conta' },
  '904_44_S26Amount': { label: '1. Saldo que aparece no extrato', section: 'Confronto — Outra conta' },
  '904_45_S26Amount': { label: '2. Depósitos registrados que não aparecem no extrato', section: 'Confronto — Outra conta' },
  '904_46_S26Amount': { label: '3. Taxas não registradas na Folha de Contas', section: 'Confronto — Outra conta' },
  '904_47_S26TotalAmount': { label: '4. Total dos itens 1 a 3', section: 'Confronto — Outra conta' },
  '904_54_S26TotalAmount': { label: '6. Total dos saques que não aparecem no extrato [soma do item 5]', section: 'Confronto — Outra conta' },
  '904_55_S26Amount': { label: '7. Juros não registrados na Folha de Contas', section: 'Confronto — Outra conta' },
  '904_56_S26TotalAmount': { label: '8. Saldo [item 4 − itens 6 e 7]', section: 'Confronto — Outra conta' },
});

// Item 5 do confronto bancário: 7 linhas (nº confirmação/cheque + valor)
for (let n = 1; n <= 7; n++) {
  fieldMap[`904_${4 + 2 * n}_Text`] = { label: `5. Pendência ${n} — N.º de confirmação/cheque`, section: 'Confronto — Conta bancária' };
  fieldMap[`904_${5 + 2 * n}_S26Amount`] = { label: `5. Pendência ${n} — Valor`, section: 'Confronto — Conta bancária' };
}
// Item 5 do confronto de outra conta: 3 linhas (descrição + valor)
for (let n = 1; n <= 3; n++) {
  fieldMap[`904_${46 + 2 * n}_Text`] = { label: `5. Saque ${n} — Descrição`, section: 'Confronto — Outra conta' };
  fieldMap[`904_${47 + 2 * n}_S26Amount`] = { label: `5. Saque ${n} — Valor`, section: 'Confronto — Outra conta' };
}

const S26_SECTION_COLORS = {
  'Cabeçalho': 'bg-blue-500',
  'Registro — Data/Descrição': 'bg-slate-500',
  'Registro — Donativos': 'bg-emerald-500',
  'Registro — Conta bancária/Cofre': 'bg-amber-500',
  'Registro — Outra conta': 'bg-indigo-500',
  'Totais do Registro': 'bg-purple-500',
  'Confronto — Conta bancária': 'bg-teal-500',
  'Confronto — Cofre': 'bg-cyan-500',
  'Resumo': 'bg-rose-500',
  'Confronto — Outra conta': 'bg-orange-500',
};

export const S26_CONFIG = {
  formType: 's26',
  title: 'S-26',
  formLabel: 'S-26',
  fieldMap,
  sectionColors: S26_SECTION_COLORS,
  totalFields: Object.keys(fieldMap).length,
};
